module.exports = __webpack_public_path__ + "img/imagen4.2297bc61.png";